//@flow
import {makeStyles, Typography} from '@material-ui/core';
import {ErrorOutline} from '@material-ui/icons';
import React from 'react';
import CustomButton from '../CustomButton/CustomButton';
import CustomModal from '../CustomModal/CustomModal';

import {colors} from '../../assets/styles/colors';

type Props = {
  open?: boolean,
  onClose?: () => void,
  message: string | React$Node,
  onCancel: () => void,
  onConfirm: () => void,
  title?: string,
  className?: string,
  confirmButtonLabel?: string,
  cancelButtonLabel?: string,
  icon?: React$Node,
};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 600,
    margin: '0 auto',
  },
  warningIcon: {
    fontSize: '1.25rem',
    width: 100,
    height: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    margin: '1rem auto',
    background: colors.warning,
    color: 'white',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  message: {
    maxWidth: 300,
    textAlign: 'center',
  },
  options: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    width: '100%',
    margin: '1rem 0',
  },
  button: {
    padding: '10px 2px',
  },
}));

export default function ConfirmModal(props: Props) {
  const {
    onClose,
    open,
    onCancel,
    onConfirm,
    message,
    className = '',
    title = '¿Estás seguro de esta acción?',
    icon,
    cancelButtonLabel = 'Cancelar',
    confirmButtonLabel = 'Confirmar',
  } = props;

  const classes = useStyles();

  const messageIsString = typeof message === 'string';

  return (
    <CustomModal
      open={open}
      handleCloseModal={onClose}
      className={`${classes.root} ${className}`}
    >
      <div className={classes.header}>
        <span className={classes.warningIcon}>
          {icon ? icon : <ErrorOutline fontSize="large" />}
        </span>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      </div>
      {messageIsString ? (
        <Typography className={classes.message}> {message}</Typography>
      ) : (
        message
      )}
      <div className={classes.options}>
        <CustomButton
          className={classes.button}
          variant="contained"
          color="default"
          onClick={onCancel}
          fullWidth
        >
          {cancelButtonLabel}
        </CustomButton>

        <CustomButton
          onClick={onConfirm}
          className={classes.button}
          variant="contained"
          fullWidth
        >
          {confirmButtonLabel}
        </CustomButton>
      </div>
    </CustomModal>
  );
}
